Vue.component('giveKey', {
  template: templates.giveKey,
  data() {
    return {
      model: {
        keyId: null,
        keys: {},
        searchResults: []
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.connect()
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {

        const messageData = event.data;

        try {

          const parsedData = JSON.parse(messageData);
          if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.message === 'key_given'){
            c.get();
          }

        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
      const c = this;
      let data = {};
      let streamerData = {};

      keyService.get()
        .then(function (response) {
 
          for (let d of response.data) {
            if(d.isStreamerOrMod){
              data[`${d.key[0].id}`] = d.key[0]
              streamerData[`${d.id}`] = d
            }
            else{
              data[`${d.id}`] = d;
            }
           
          }
        
         
          c.model.keys = data;
          c.model.streamerKeys = streamerData;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="key-user"]').val();

      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data;
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
          }
          
          $('[name="key-user"]').autocomplete({
            source: names
          });
        })
        .catch(function (error) {
        
        });
    },
    getUserId(twitchDisplayName, callback) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          callback(user.twitchId);
          return;
        }
      }

      twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {

        for (let data of userData) {
          callback(data.id);
          return;
        }
        
        callback(null);

      });
    },
    save() {
      const c = this;
      const twitchDisplayName = $('[name="key-user"]').val();

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId || !c.model.keyId) {
          utils.alert.error('User and key required!');
          return;
        }

        const data = {
          twitchId: twitchId,
          keyId: c.model.keyId
        }

        keyService.unlock(data)
          .then(function (response) {
            c.reset();
            c.get();
            let data = {
              channelId: utils.cookies.get('channelId'),
              message: 'key_given',
            }
            c.ws.send(JSON.stringify(data));
            utils.alert.success(response.data.message);
          })
          .catch(function (error) {
            utils.alert.error(error.response.data.message);
          });

      });
    },
    reset() {
      const c = this;
      $('[name="key-user"]').val('');
      c.model.keyId = null;
    },
    getKeyImageUrl(streamerKey) {
      const c = this;
      
      if (streamerKey && streamerKey.key && streamerKey.key[0] && streamerKey.key[0].id) {
        const keyId = streamerKey.key[0].id;
        return `${root}/images/keys/${keyId}.png`;
      }
      
      return null;
    }
  }
});